export function initQuiz() {
  const container = document.querySelector('[data-quiz]');
  if (!container) return;

  const panels = container.querySelectorAll('[data-question]');
  const btnNext = container.querySelector('[data-quiz-next]');
  const btnPrev = container.querySelector('[data-quiz-prev]');
  const btnSubmit = container.querySelector('[data-quiz-submit]');
  const counterCurrent = document.querySelector('[data-q-current]');
  const progressFill = document.querySelector('[data-quiz-progress]');
  const navBtns = document.querySelectorAll('[data-nav-q]');

  let current = 0;
  const total = panels.length;
  const answered = new Set();

  function show(index) {
    panels.forEach((p, i) => p.classList.toggle('hidden', i !== index));
    current = index;

    if (counterCurrent) counterCurrent.textContent = toArabicNum(index + 1);
    if (progressFill) progressFill.style.width = `${Math.round(((index + 1) / total) * 100)}%`;

    if (btnPrev) btnPrev.classList.toggle('invisible', index === 0);
    const isLast = index === total - 1;
    if (btnNext) btnNext.classList.toggle('hidden', isLast);
    if (btnSubmit) btnSubmit.classList.toggle('hidden', !isLast);

    navBtns.forEach(btn => {
      const q = parseInt(btn.dataset.navQ) - 1;
      const isAnswered = answered.has(q);
      const isCurrent = q === index;

      btn.classList.remove(
        'ring-2', 'ring-dcco-primary/30',
        'bg-dcco-primary', 'text-white', 'font-bold', 'border-2', 'border-dcco-primary',
        'bg-dcco-secondary/10', 'border-dcco-secondary', 'text-dcco-secondary',
        'bg-gray-50', 'bg-dcco-surface-light', 'dark:bg-dcco-surface-dark', 'text-dcco-muted', 'border-gray-200', 'dark:border-dcco-border-dark',
        'bg-green-100', 'text-green-700', 'border-green-200'
      );

      if (isCurrent) {
        btn.classList.add('bg-dcco-primary', 'text-white', 'border-2', 'border-dcco-primary', 'ring-2', 'ring-dcco-primary/30', 'font-bold');
        btn.textContent = String(q + 1);
      } else if (isAnswered) {
        btn.classList.add('bg-dcco-secondary/10', 'border-dcco-secondary', 'text-dcco-secondary');
        btn.innerHTML = '<i class="fa-solid fa-check text-xs"></i>';
      } else {
        btn.classList.add('bg-gray-50', 'dark:bg-dcco-surface-dark', 'text-dcco-muted', 'border-gray-200', 'dark:border-dcco-border-dark');
        btn.textContent = String(q + 1);
      }
    });
  }

  if (btnNext) btnNext.addEventListener('click', () => { if (current < total - 1) show(current + 1); });
  if (btnPrev) btnPrev.addEventListener('click', () => { if (current > 0) show(current - 1); });
  navBtns.forEach(btn => btn.addEventListener('click', () => show(parseInt(btn.dataset.navQ) - 1)));

  container.addEventListener('change', e => {
    const panel = e.target.closest('[data-question]');
    if (!panel) return;
    const idx = parseInt(panel.dataset.question) - 1;
    answered.add(idx);
    show(current);
  });

  initSortable();
  show(0);
}

function initSortable() {
  const list = document.querySelector('[data-sortable]');
  if (!list) return;

  let dragged = null;

  list.addEventListener('dragstart', e => {
    dragged = e.target.closest('[data-sort-item]');
    if (dragged) { setTimeout(() => dragged.classList.add('opacity-40'), 0); }
  });

  list.addEventListener('dragend', () => {
    if (dragged) { dragged.classList.remove('opacity-40'); dragged = null; }
    updateOrderNumbers(list);
  });

  list.addEventListener('dragover', e => {
    e.preventDefault();
    const target = e.target.closest('[data-sort-item]');
    if (target && dragged && target !== dragged) {
      const rect = target.getBoundingClientRect();
      const after = e.clientY > rect.top + rect.height / 2;
      list.insertBefore(dragged, after ? target.nextSibling : target);
    }
  });
}

function updateOrderNumbers(list) {
  list.querySelectorAll('[data-sort-num]').forEach((el, i) => {
    el.textContent = toArabicNum(i + 1);
  });
}

function toArabicNum(n) {
  return String(n).replace(/\d/g, d => '٠١٢٣٤٥٦٧٨٩'[d]);
}
